import { createContext, useContext } from "react";

// True when a page is rendered inside the CRM PortalShell (sidebar + CRM topbar).
// The legacy <Navbar/> reads this and renders nothing inside the shell, so the
// CRM Topbar is the single, consistent top bar across all portal pages.
export const ShellContext = createContext(false);

export const useInShell = () => useContext(ShellContext);
